import * as _ from './shipto.model';
export class SalesOrgModel{
    cgcode:string
    cust_code:string
    salesorg:string
    division:string
    distchannel:string
    shipto_list: _.ShiptoModel[]
    partial_dlvy_flag:string
    payment_term:string
    //STRY0017537 [TH] Order save/ submission - pop up notification for copy of PO for government hospital start
    custClassfication:string
    //STRY0017537 [TH] Order save/ submission - pop up notification for copy of PO for government hospital end
}


// WEBPACK FOOTER //
// ./src/models/customer/salesorg.model.ts